<template>
  <div class="padding-five-all">
     
    <b-tabs  v-model="tabIndex" >
      
       
      <activity :tabIndex="tabIndex" > </activity>
      <b-tab active :title-link-class="linkClass(1)"  >
        <template #title>
          <font-awesome-icon class="fa-regultar" icon="house-user" /> Orden de
          servicios
        </template>
        <section>
          <b-container fluid>
            <b-row>
              <b-col cols="12" lg="6" class="my-1">
                <h5 class="color-dark font-weight-bold">Orden de Servicios</h5>
              </b-col>
              <b-col cols="12" lg="6" class="my-1 float-right">
                <b-row class="float-right">
                  <b-col cols="auto">
                    <b-button
                      class="btn-blue"
                      @click="$bvModal.show('modal-2')"
                    >
                      <font-awesome-icon class="fa-regultar" icon="download" />
                      Exportar a excel
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" lg="3" class="my-1">
                <label class="font-weight-bold">Tienda</label>
                <combo-store
                  v-model="selectedStore"
                  v-bind:isComboSelected="false"
                />
              </b-col>
              <b-col cols="12" lg="3" class="my-1">
                <label class="font-weight-bold">Estado</label>
                <b-form-group>
                  <b-form-select
                    @change="getSubstates"
                    v-model="selectedState"
                    size="md"
                    :options="optionStates"
                  >
                    <template #first>
                      <b-form-select-option :value="null"
                        >Todas las opciones
                      </b-form-select-option>
                    </template>
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col cols="12" lg="3" class="my-1">
                <label class="text-dark font-weight-bold">Sub Estado</label>
                <b-form-group>
                  <b-form-select
                    v-model="selectedFilterState"
                    size="md"
                    :options="optionSubstate"
                  ></b-form-select>
                </b-form-group>
              </b-col>
              <b-col cols="12" lg="3" class="my-1">
                <label class="text-dark font-weight-bold">Número de OS</label>
                <b-form-input
                  placeholder="Escribir"
                  type="text"
                  v-model="numberOs"
                ></b-form-input>
              </b-col>
              
            </b-row>
            <b-row>
              <b-col cols="12" lg="3" class="my-1">
                <label class="text-dark font-weight-bold">Fecha Inicio</label>
                <b-form-input type="date" v-model="startDate"></b-form-input>
              </b-col>
              <b-col cols="12" lg="3" class="my-1">
                <label class="text-dark font-weight-bold">Fecha Fin</label>
                <b-form-input type="date" v-model="endDateOrder"></b-form-input>
              </b-col>
              <b-col cols="12" lg="3" class="my-1">
                <label class="text-dark font-weight-bold">Proveedor</label>
                <template v-if="isProfileProvider">
                  <b-form-group>
                    <b-form-select
                      :disabled="true"
                      v-model="selectedProvider.id"
                      size="md"
                      :options="optionsProvider"
                    >
                    </b-form-select>
                  </b-form-group>
                </template>
                <template v-else>
                  <b-form-group>
                    <b-form-select
                      v-model="selectedProvider"
                      size="md"
                      :options="optionsProvider"
                    >
                      <template #first>
                        <b-form-select-option
                          :value="selectedProvider.user == null"
                        >
                          Todos
                        </b-form-select-option>
                      </template>
                    </b-form-select>
                  </b-form-group>
                </template> 
              </b-col>
              
              <b-col cols="12" lg="3" class="my-1">
                <label class="hidden margin-0">Hidden</label>
                <b-button @click="search" class="btn-dark width-100">
                  <font-awesome-icon icon="search" /> Buscar
                </b-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" lg="3" class="my-1">
                <label class="text-dark font-weight-bold">Documento Cliente</label>
                <b-form-input
                  placeholder="Escribir"
                  type="text"
                  v-model="documentNumber"
                ></b-form-input>
              </b-col>
              
            </b-row> 
          </b-container>
        </section>
        <section class="bcg-white">
          <b-container fluid class="padding-lr-none">
            <b-row>
              <b-col cols="12">
                <b-table
                  :busy="isBusy"
                  :current-page="currentPage"
                  :per-page="0"
                  striped
                  :items="orderServices"
                  :fields="fieldsRoutes"
                >
                  <template #table-busy>
                    <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>Loading...</strong>
                    </div>
                  </template>
                  <template #cell(identifier)="data">
                    <span>{{ data.item.identifier }} </span>
                    <b-button
                      :disabled="enableEdit(data.item)"
                      class="btn-underline"
                      @click="openEdit(data.item)"
                    >
                      Editar
                    </b-button>
                    <b-button
                      class="btn-underline"
                      @click="openModalWatch(data.item)"
                    >
                      Ver
                    </b-button>
                  </template>
                  <template #cell(descState)="data">
                    <span>{{ data.item.descState }} </span>
                    <span>{{ data.item.descSubState }} </span>
                  </template>
                </b-table>
                <b-pagination
                  v-model="currentPage"
                  :total-rows="rowsTable"
                  :per-page="perPage"
                  pills
                  limit="4"
                  first-number
                  hide-goto-end-buttons
                  align="center"
                  size="md"
                  class="my-0"
                ></b-pagination>
              </b-col>
            </b-row>
          </b-container>
        </section>
      </b-tab>
    </b-tabs>
    <b-modal
      v-model="modalShowEdit"
      hide-footer
      id="modal-registrar-serv"
      title="Editar Ruta"
    >
      <modal-edit
        @refreshData="refreshData"
        :idService.sync="idService"
        :idRoute.sync="idRoute"
        :orderService.sync="orderService"
        :currentState.sync="currentState"
        :typeOs.sync="typeOs"
        :idOsDet.sync="idOsDet"
        :clientName.sync="clientName"
        :store.sync="store"
        :modalShowEdit.sync="modalShowEdit"
      />
    </b-modal>

    <b-modal
      v-model="modalWatch"
      hide-footer
      id="modal-registrar-serv"
      title="Ver ruta"
    >
      <modal-watch
        :idService="idService"
        :idRoute.sync="idRoute"
        :orderService.sync="orderService"
        :currentState.sync="currentState"
        :modalWatch.sync="modalWatch"
      />
    </b-modal>
    <b-modal
      id="modal-1"
      hide-footer
      title="Exportar a excel"
      title-class="left-auto"
    >
      <b-container fluid>
        <b-row class="mb-1 text-center">
          <b-alert show class="text-dark border-sky-all"
            >Los reportes generados tiene un límite 5000 filas</b-alert
          >
          <p class="text-dark text-left">
            Una vez solicitado el reporte será enviado al correo electrónico
            específicado
          </p>
        </b-row>

        <b-row>
          <b-col cols="12" lg="6" class="my-1">
            <label class="text-dark font-weight-bold">Fecha Inicio</label>
            <b-form-input
              type="date"
              v-model="dateEstimatedBegin"
            ></b-form-input>
          </b-col>
          <b-col cols="12" lg="6" class="my-1">
            <label class="text-dark font-weight-bold">Fecha Fin</label>
            <b-form-input type="date" v-model="endDate"></b-form-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" lg="8" md="8">
            <label class="text-dark font-weight-bold">Proveedor</label>
            <template v-if="isProfileProvider">
              <b-form-group>
                <b-form-select
                  :disabled="true"
                  v-model="selectedProvider.id"
                  size="md"
                  :options="optionsProvider"
                >
                </b-form-select>
              </b-form-group>
            </template>
            <template v-else>
              <b-form-group>
                <b-form-select
                  v-model="selectedProvider"
                  size="md"
                  :options="optionsProvider"
                >
                  <template #first>
                    <b-form-select-option :value="null">
                      Todos
                    </b-form-select-option>
                  </template>
                </b-form-select>
              </b-form-group>
            </template> 
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" lg="8" md="8">
            <label class="text-dark font-weight-bold">Tienda</label>
            <combo-store
              v-model="selectedStore"
              v-bind:isComboSelected="false"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <label class="text-dark font-weight-bold"
              >Correo electrónico de destino
            </label>
            <b-form-input
              @keyup="validateEmail"
              class="border-all"
              placeholder="Escribir"
              type="text"
              v-model="emailUser"
            >
            </b-form-input>
            <p>{{ msg }}</p>
          </b-col>
        </b-row>

        <b-row>
          <b-col lg="6" class="padding-left-none">
            <b-button
              class="width-100 bg-white btn-white-v border-black-all color-gray"
              @click="$bvModal.hide('modal-1')"
            >
              Cancelar
            </b-button>
          </b-col>
          <b-col lg="6" class="padding-rigth-none">
            <b-button
              :disabled="isEnabledEmail"
              class="btn-dark width-100"
              @click="saveReport"
            >
              Enviar
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
    <b-modal
      id="modal-2"
      hide-footer
      title="Exportar a excel"
      title-class="left-auto"
    >
      <b-container fluid>
        <b-row class="mb-1 text-center">
          <b-alert show class="text-dark border-sky-all"
            >Los reportes generados tiene un límite 5000 filas</b-alert
          >
          <p class="text-dark text-left">
            Una vez solicitado el reporte será enviado al correo electrónico
            específicado
          </p>
        </b-row>
        <b-row>
          <b-col cols="12" lg="6" class="my-1">
            <label class="text-dark font-weight-bold">Fecha Inicio</label>
            <b-form-input
              type="date"
              v-model="dateEstimatedBegin"
            ></b-form-input>
          </b-col>
          <b-col cols="12" lg="6" class="my-1">
            <label class="text-dark font-weight-bold">Fecha Fin</label>
            <b-form-input type="date" v-model="endDate"></b-form-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" lg="8" md="8" class="my-1">
            <label class="text-dark font-weight-bold">Proveedor</label>
            <template v-if="isProfileProvider">
              <b-form-group>
                <b-form-select
                  :disabled="true"
                  v-model="selectedProvider.id"
                  size="md"
                  :options="optionsProvider"
                >
                </b-form-select>
              </b-form-group>
            </template>
            <template v-else>
              <b-form-group>
                <b-form-select
                  v-model="selectedProvider"
                  size="md"
                  :options="optionsProvider"
                >
                  <template #first>
                    <b-form-select-option :value="null">
                      Todos
                    </b-form-select-option>
                  </template>
                </b-form-select>
              </b-form-group>
            </template> 
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" lg="8" md="8" class="my-1">
            <label class="text-dark font-weight-bold">Tienda</label>
            <combo-store
              v-model="selectedStore"
              v-bind:isComboSelected="false"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <label class="text-dark font-weight-bold"
              >Correo electrónico de destino
            </label>
            <b-form-input
              @keyup="validateEmail"
              class="border-all"
              placeholder="Escribir"
              type="text"
              v-model="emailUser"
            ></b-form-input>
            <p>{{ msg }}</p>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="6" class="padding-left-none">
            <b-button
              class="width-100 bg-white btn-white-v border-black-all color-gray"
              @click="$bvModal.hide('modal-2')"
            >
              Cancelar
            </b-button>
          </b-col>
          <b-col lg="6" class="padding-rigth-none">
            <b-button
              :disabled="isEnabledEmail"
              class="btn-dark width-100"
              @click="saveReport"
            >
              Enviar
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
    <!-- <b-modal
      hide-footer
      id="modal-photos"
      title="Adjuntar fotos"
      title-class="left-auto"
      header-class="bg-light"
    >
      <photos :idRoute.sync="idRoute" />
    </b-modal>

    <b-modal
      centered
      size="lg"
      hide-footer
      id="modal-carousel"
      title="Ver fotos"
      title-class="left-auto"
    >
      <carousel :photos="photos" />
    </b-modal>
    <b-modal
      centered
      size="lg"
      hide-footer
      id="modal-signatures"
      title="Ver fotos"
      title-class="left-auto"
    >
      <carousel :photos="signatures" />
    </b-modal> -->
  </div>
</template>

<script>
import ComboStore from "../../components/ComboStore.vue";
import axios from "axios";
import moment from "moment";
import { mapState } from "vuex";
import ModalEdit from "../../components/OneTrack/ModalEdit.vue";
import ModalWatch from "../../components/OneTrack/ModalWatch.vue";
//import Photos from "../../components/OneTrack/Photos.vue";
//import store from "@/store";
//import Carousel from "../../components/OneTrack/Carousel.vue";
import Activity from '../../components/OneTrack/Activity.vue';
export default {
  name: "OneTrack",
  data() {
    return {
      countRecords: 20,
      hours: ["08:00", "09:00", "10:00", "11:00", "12:00", "13:00", "14:00"],
      activeClass: "active-realized",
      inactiveClass: "unrealized",
      errorClass: "text-danger",
      max: 100,
      msg: "",
      modalShowPhotos: false,
      modalShowEdit: false,
      modalWatch: false,
      modalShow: false,
      emailUser: "",
      selectedStore: null,
      numberOs: "",
      documentNumber: null,
      identityDoc: "",
      startDate: moment().format("YYYY-MM-DD"),
      endDateOrder: moment().format("YYYY-MM-DD"),
      dateEstimatedBegin: moment().format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
      actualDate: moment().format("YYYY-MM-DD"),
      optionSubstate: [],
      selectedFilterState: "",
      optionsProvider: [],
      selectedProvider: { id: null, user: null },
      selectedOptionProvider:{id: null, user: ""},
      optionStates: [],
      selectedState: { idTypeMotive: null, idState: null },
      dataRoutes: "",
      fieldsRoutes: [
        { key: "selected", label: "  " },
        { key: "identifier", label: "Orden de servicios" },
        { key: "descState", label: "Estado" },
        { key: "truck_identifier", label: "Técnico" },
        { key: "client_full_name", label: "Cliente" },
        { key: "date", label: "Fecha de ruta" },
      ],
      currentPage: 1,
      perPage: 10,
      countTotal: 10,
      isBusy: false,
      tabIndex: 0,
      orderService: "",
      currentState: "",
      idRoute: 0,
      idService: 0,
      idOsDet:0,
      clientName:"",
      store:"",
      client: {
        fullName: "",
        identityDocument: "",
        address: "",
        referenceAdress: "",
      },
      orderServices: [],
      photos: [],
      signatures: [],
      typeOs:""

    };
  },
  components: { ComboStore, ModalEdit, ModalWatch, Activity },
  computed: {
    isProfileProvider() {
      let up = this.perfil.toUpperCase();
      if (up === "PROVEEDOR") return true;
      return false;
    },
    rowsTable() {
      if (this.currentPage == 1 && this.orderServices.length < 10) return 10;
      return this.countRecords;
    },
    totalUnrealized() {
      let routesUnrealized = 0;
      let totalRoutes = 0;

      this.routes.forEach((element) => {
        element.services.forEach((a) => {
          if (a.state == 7) {
            routesUnrealized++;
          }
          totalRoutes++;
        });
      });
      let complaince = (routesUnrealized * 100) / totalRoutes;
      if (this.routes.length && routesUnrealized > 0)
        return complaince.toFixed(2);
      else return 0;
    },
    totalPartial() {
      let routesPartial = 0;
      let totalRoutes = 0;

      this.routes.forEach((element) => {
        element.services.forEach((a) => {
          if (a.state == 11) {
            routesPartial++;
          }
          totalRoutes++;
        });
      });
      let complaince = (routesPartial * 100) / totalRoutes;
      if (this.routes.length && complaince > 0) return complaince.toFixed(2);
      else return 0;
    },
    totalAsigned() {
      let total = 0;
      if (this.routes.length) {
        this.routes.forEach((element) => {
          element.services.forEach(() => {
            total++;
          });
        });
      }

      if (this.routes.length && total > 0) return total;
      else return 0;
    },
    totalRealized() {
      let routesRealized = 0;
      let totalRoutes = 0;
      if (this.routes.length) {
        this.routes.forEach((element) => {
          element.services.forEach((a) => {
            if (a.state == 3) {
              routesRealized++;
            }
            totalRoutes++;
          });
        });
      }
      let complaince = (routesRealized * 100) / totalRoutes;
      if (this.routes.length && routesRealized > 0)
        return complaince.toFixed(2);
      else return 0;
    },
    totalManaged() {
      let routesManaged = 0;

      this.routes.forEach((element) => {
        element.services.forEach((a) => {
          if (a.state == 3 || a.state == 7 || a.state == 13) {
            routesManaged++;
          }
        });
      });

      if (this.routes.length) return routesManaged;
      else return 0;
    },
    totalCompliance() {
      let routesCompliance = 0;
      let totalRoutes = 0;
      if (this.routes.length) {
        this.routes.forEach((element) => {
          element.services.forEach((a) => {
            if (a.state == 3 || a.state == 7 || a.state == 13) {
              routesCompliance++;
            }
            totalRoutes++;
          });
        });
      }
      let complaince = (routesCompliance * 100) / totalRoutes;
      if (this.routes.length && routesCompliance > 0)
        return complaince.toFixed(2);
      else return 0;
    },
    isEnabledSerach() {
      if (this.perfil === "ADMINISTRADOR" || this.perfil === "Proveedor")
        return true;
      else return false;
    },
    /*usersInRoute() {
      return 0;
    }, */
    isEnabledEmail() {
      if (this.msg) return true;
      else return false;
    },
    totalRoutes() {
      if (this.currentPage == 1 && this.routes.length < 10) return 10;
      return this.countTotal;
    },
    ...mapState("module", ["username", "perfil", "idProvider","token"]),
  },
  created() {
    this.getStates();
    this.getProviders();
  },
  /*beforeRouteEnter(to, from, next) {
    let profile = store.getters["module/profile"];
    console.log(profile);
    let auth =
      profile === "ADMINISTRADOR" || profile === "Proveedor" ? true : false;
    if (!auth) next({ name: "BlockedPage" });
    else next();
  },*/
  watch: {
    currentPage: {
      handler: function () {
        this.search()
          .then((res) => {
            if (res.length < 10) return;
            this.countRecords = this.countRecords + 20;

            console.log(this.countRecords, res);
          })
          .catch((error) => {
            console.error(error);
          });
      },
    },
  },
  methods: {
    
    enableEdit(item) {
      if (item.state == 2) return false;
      else return true;
    },
    complianceTotal(item) {
      let route = item.services.filter((item) => item.state == 3);
      let doneRoutes = route.length;
      let totalRoutes = item.services.length;
      let complaince = (doneRoutes * 100) / totalRoutes;
      if (doneRoutes <= 0 && totalRoutes != null) return 0;
      else return complaince;
    },
    complianceTotalNoRealized(item) {
      let route = item.services.filter((item) => item.state == 7);
      let doneRoutes = route.length;
      let totalRoutes = item.services.length;
      let complaince = (doneRoutes * 100) / totalRoutes;
      if (doneRoutes <= 0 && totalRoutes != null) return 0;
      else return complaince;
    },
    assignedRoute(item) {
      return item.services.length;
    },
    managedRoutes(item) {
      let route = item.services.filter(
        (item) => item.state == 3 || item.state == 7
      );
      return route.length;
    },
    compliancePercentageRoutes(item) {
      let route = item.services.filter(
        (item) => item.state == 3 || item.state == 7
      );
      let doneRoutes = route.length;
      let totalRoutes = item.services.length;
      let complaince = (doneRoutes * 100) / totalRoutes;
      if (doneRoutes <= 0 && totalRoutes != null) return 0;
      else return Number(complaince.toFixed(2));
    },
    realizedRoutes(item) {
      let route = item.services.filter((item) => item.state == 3);
      return route.length;
    },
    NoRealizedRoutes(item) {
      let route = item.services.filter((item) => item.state == 7);
      return route.length;
    },
  
    
    async getPhotosRoute(item) {
      try {
        if (this.photos.length) this.photos = [];
        let response = await axios.get(
          process.env.VUE_APP_BASE_ONETRACK + "/route/photo/" + item.idRoute
        );
        this.photos = response.data;
      } catch (e) {
        console.log(e);
      }
    },
    async getSignatureClient(item) {
      try {
        if (this.signatures.length) this.signatures = [];
        let response = await axios.get(
          process.env.VUE_APP_BASE_ONETRACK + "/route/signature/" + item.idRoute
        );
        const data = response.data.map((row) => {
          return {
            id: row.id,
            idRoute: row.idRoute,
            photoUrl: row.signatureUrl,
            username: row.username,
          };
        });
        this.signatures = data;
      } catch (e) {
        console.log(e);
      }
    },
    linkClass(idx) {
      if (this.tabIndex === idx) {
        return ["link-active"];
      } else {
        return ["transparent"];
      }
    },
    openModalWatch(item) {
      this.modalWatch = !this.modalWatch;
      this.orderService = item.identifier;
      this.idRoute = item.idRoute;
      this.idService = item.idService;
    },
    openEdit(item) {
      console.log(item)
      this.modalShowEdit = !this.modalShowEdit;
      this.orderService = item.identifier;
      this.idRoute = item.idRoute;
      this.idService = item.idService;
      this.typeOs=item.typeOs;
      this.idOsDet=item.idOsDet;
      this.clientName=item.client_full_name;
      this.store=item.store;
    },

    getDataClient(item) {
      console.log(item);
      this.client.fullName = item.client_full_name;
      this.client.identityDocument = item.identityDocument;
      this.client.address = item.contact_address;
      this.client.referenceAdress = item.service_observation;
    },
    async getStates() {
      try {
        let response = await axios.get(
          process.env.VUE_APP_BASE_ONETRACK_STATE + "/state"
        );
        const data = response.data.map((row) => {
          return {
            value: { idTypeMotive: row.idTypeMotive, idState: row.idState },
            text: row.descripcionState,
          };
        });
        this.optionStates = data;
      } catch (e) {
        console.log(e);
      }
    },
    async getSubstates() {
      try {
        if (!this.selectedState) return;
        let response = await axios.get(
          process.env.VUE_APP_BASE_MOTIVOS +
            "/motives/v2?responsible=13&type=" +
            this.selectedState.idTypeMotive
        );
        const data = response.data.map((row) => {
          return {
            value: row.id,
            text: row.description,
          };
        });
        this.optionSubstate = data;
      } catch (error) {
        console.log(error);
      }
    },
    validateEmail() {
      const mailRegex =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!mailRegex.test(this.emailUser)) {
        this.msg = "Ingrese un email válido";
      } else {
        this.msg = "";
      }
    },
    async saveReport() {
      try {
        this.$store.commit("SET_LOADING", true);
        let providerId = null;
        if (this.selectedProvider) {
          providerId = this.selectedProvider.id;
        }
        let response = await axios.post(
          process.env.VUE_APP_BASE_ONETRACK + "/route/report",
          {
            email: this.emailUser,
            provider: providerId,
            technical: "",
            dateEstimatedBegin: this.dateEstimatedBegin,
            dateEstimatedEnd: this.endDate,
            store: this.selectedStore,
            status: 0,
            subStatus: 0,
            numOs: "",
            user: this.username,
          }, // the data to post
          {
            headers: {
              "Content-type": "application/json",
            },
          }
        );
        console.log(response);
        let values = { variant: "success", msg: "Se registro exitosamente !" };
        this.$store.commit("setShowAlert", true);
        this.$store.commit("SET_ERROR_MSG", values);
        this.$bvModal.hide("modal-1");
        this.$bvModal.hide("modal-2");
      } catch (error) {
        let values = { variant: "danger", msg: error.response.data.message };
        this.$store.commit("setShowAlert", true);
        this.$store.commit("SET_ERROR_MSG", values);
        console.log(error);
      } finally {
        this.$store.commit("SET_LOADING", false);
        setTimeout(() => {
          this.$store.commit("setShowAlert", false);
        }, 3000);
      }
    },
    refreshData() {
      this.search();
    },
    async search() {
      try {
        let userProvider = "";
        if (this.perfil === "PROVEEDOR") {
          userProvider = "&UserProvider=" + encodeURIComponent(this.username);
        } else if (this.selectedProvider?.user) {
          userProvider = "&UserProvider=" + encodeURIComponent(this.selectedProvider.user);
        }
        this.isBusy = true;
        let stateFilter = this.selectedState?.idState
          ? "&state=" + this.selectedState.idState
          : "";
        let store = this.selectedStore ? "&Store=" + this.selectedStore : "";
        let numOs = this.numberOs ? "&NumOs=" + this.numberOs : "";
        let docId=this.documentNumber? "&DocIdentidad=" + this.documentNumber : "";
        let response = await axios.get(
          process.env.VUE_APP_BASE_ONETRACK +
            "/route/provider?page=" +
            this.currentPage +
            "&limit=" +
            this.perPage +
            "&pagination=true" +
            userProvider +
            "&Date=" +
            this.startDate +
            "&DateEnd=" +
            this.endDateOrder +
            stateFilter +
            store +
            numOs+
            docId
        );
        this.countTotal = response.data.countTotal;
        const list = response.data.routes.map((row) => {
          return {
            services: row.services,
            truck_identifier: row.truck_identifier,
            date: row.date,
            idRoute: row.idRoute,
          };
        });
        const services = list.map((row) => {
          console.log(row);
          return {
            identifier: row.services[0].identifier,
            client_full_name: row.services[0].client_full_name,
            truck_identifier: row.truck_identifier,
            descState: row.services[0].descState,
            descSubState: row.services[0].descSubState,
            date: row.date,
            idRoute: row.idRoute,
            state: row.services[0].state,
            idService: row.services[0].idService,
            typeOs: row.services[0].typeOs,
            idOsDet:row.services[0].idOsDet,
            store:row.services[0].idstore
          };
        });
        this.orderServices = services;
        return services;
      } catch (error) {
        console.log(error);
      } finally {
        this.isBusy = false;
      }
    },
    async getProviders() {
      if (this.isProfileProvider) {
        this.selectedProvider.id = this.idProvider;
        this.getFilteredProviders();
      } else {
        this.getProvidersList();
      }
    },
    async getFilteredProviders() {
      try {
        let response = await axios.get(
          process.env.VUE_APP_ENDPOINT_PROVIDERS_CORE_BASE +
            "/providers/" +
            this.idProvider,
            {
              headers: {
              "Content-type": "application/json",
              "Authorization": "Bearer "+ this.token
              },
            }
        );
        let arr = [];
        arr.push(response.data);

        const data = arr.map((row) => {
          return {
            value: row.id,
            text: row.user,
          };
        });
        this.optionsProvider = data;
        this.selectedProvider.id = this.idProvider;
      } catch (error) {
        console.log(error);
      }
    },
    async getProvidersList() {
      try {
        let response = await axios.get(
          process.env.VUE_APP_ENDPOINT_PROVIDERS_CORE_BASE +
            "/providers?limit=1000&state=ACTIVE&page=1&pagination=false",
            {
              headers: {
              "Content-type": "application/json",
              "Authorization": "Bearer "+ this.token
            },
            }
        );
        const data = response.data.map((row) => {
          return {
            value: { user: row.user, id: row.id },
            text: row.user,
          };
        });
       var sortedData= data.sort((a,b) => a.text.localeCompare(b.text))
        this.optionsProvider = sortedData;
      } catch (error) {
        console.log(error);
      } finally {
        //this.$store.commit("SET_LOADING", false)
      }
    },
    setProvider(e){
      console.log(e.user)
      this.selectedOptionProvider=e;
    },
 
    
  },
};
</script>

<style scoped>
.hidden {
  visibility: hidden;
}
.margin-0 {
  margin-bottom: 0;
}
.color-dark {
  color: #405568 !important;
}
.btn-dark {
  background-color: #405568 !important;
  border-color: #405568 !important;
  color: white;
  border-radius: 4px;
}
.float-right {
  float: right !important;
}
.btn-transparent {
  color: transparent;
  background-color: transparent !important;
  color: #405568 !important;
  border-color: #405568;
  border-radius: 4px;
}
.btn-blue {
  background-color: #1b8cf3 !important;
  color: white !important;
  border-color: #1b8cf3 !important;
  border-radius: 4px;
}
.btn-blue:hover {
  color: #1b8cf3 !important;
  background: white !important ;
}
.btn-underline {
  background-color: transparent !important;

  border-radius: 0 !important;
  color: #626262 !important;
  text-decoration: underline;
  border-color: transparent !important
;
}
::v-deep .nav-link:hover {
  border: none !important;
}
::v-deep .b-table thead tr {
  background-color: #f0faff !important;
  border-color: #f0faff !important;
}
::v-deep .b-table thead {
  background-color: red !important;
  color: black !important;
  font-weight: 500 !important;
  border: none !important;
}
.bcg-white {
  background-color: white !important;
}
.padding-lr-none {
  padding-left: 0%;
  padding-right: 0%;
}
.text-dark {
  color: #626262 !important;
  font-size: 14px;
}
.btn-white-v:hover {
  color: white !important;
  background: #626262 !important ;
}
.border-all {
  border: 1px solid #d8d8d8 !important;
}
.border-black-all {
  border: 1px solid #405568 !important;
}
.padding-left-none {
  padding-left: 0 !important;
}
.padding-rigth-none {
  padding-right: 0% !important;
}
.border-sky-all {
  border: 1px solid #71c2fc !important;
  background-color: #eff7ff !important;
}
::v-deep .page-item.active .page-link {
  background: #ff7a00;
  color: white;
  border-color: transparent;
}
::v-deep .page-item.disabled .page-link {
  background: transparent !important;
  border-color: transparent !important;
  color: #ff7a00;
}
::v-deep .page-link {
  color: #676767;
  border-color: transparent;
  font-weight: bold;
  background: transparent;
}
::v-deep .nav-tabs {
  position: absolute !important;
  top: 1% !important;
  z-index: 99 !important;
  left: 30%;
  border-bottom: 0;
}

::v-deep .nav-item {
  border: 1px solid #dee2e6;
}

::v-deep .link-active {
  border-bottom: 3px solid #fb822a !important;
  color: #fb822a !important;
}
.text-large-gray {
  font-size: 16px;
  color: #4e4e4e;
  font-weight: 500;
  line-height: 19px;
}
h3 {
  font-size: 32px !important;
  font-weight: 700 !important;
  line-height: 38px;
  color: #4e4e4e;
}
.bg-white {
  background-color: white !important;
  padding: 5px;
  border-radius: 8px;
  border: 1px solid #ebebeb;
  box-shadow: 0px 6px 6px rgba(0, 0, 0, 0.03);
}
.bg-sky {
  background-color: #f4faff !important;
}
.txt-lg {
  font-size: 26px;
  font-weight: 700;
}
.margin-bottom-5 {
  margin-bottom: 2%;
}
.border-all-gray {
  border: 2px solid #dddddd;
  background-color: transparent;
}
.text-md {
  font-size: 18px;
  line-height: 21px;
}
.padding-two-tb {
  padding-top: 2%;
}

.margin-none-lr {
  margin-left: 0;
  margin-right: 0;
}
.padding-two-lr {
  padding-left: 2%;
  padding-right: 2%;
}

.color-orange {
  color: #fb822a;
}

.padding-three-top {
  padding-top: 3%;
}
.border-radius-50 {
  border-radius: 50%;
  border: 1px solid #eeeeee;
  box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.05);
}
.active-realized {
  background-color: #19be2b !important ;
  border: 1px solid #19be2b !important;
  border-radius: 4px;

  font-size: 13px;
  line-height: 15px;

  color: #ffffff !important;
}

.unrealized {
  background-color: #fb465c;
  border: 1px solid #fb465c;
  border-radius: 4px;
  color: white;
  font-size: 13px;
  line-height: 15px;

  color: #ffffff !important;
}
.modal-title {
  text-align: center !important;
}
::v-deep .left-auto {
  margin-left: auto !important;
}
.bg-light {
  background-color: #f7f7f7;
}
::v-deep .nav-link .active{
border-bottom: 3px solid #fb822a !important;
    color: #fb822a !important;
}

</style>
